import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsIn,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
  ValidateIf,
} from 'class-validator';
import {
  DEADLINE_ASSIGNEE_ID_MAX_LENGTH,
  DEADLINE_TITLE_MAX_LENGTH,
  MAX_RENEWAL_VALIDITY_MONTHS,
} from './deadline.constants';
import {
  DEADLINE_RECURRENCE_CHOICES,
  type DeadlineRecurrenceChoice,
} from './deadline-management.constants';
import { DeadlineWarningDaysDto } from './deadline-warning-days.dto';
import { IsIsoDay } from './is-iso-day.decorator';

/** Valori del form "Questo documento ha una scadenza?" (spec §11.1); solo lato client. */
export class DeadlineRecurrenceFormDto extends DeadlineWarningDaysDto {
  @IsIn(DEADLINE_RECURRENCE_CHOICES)
  recurrence?: DeadlineRecurrenceChoice;

  @ValidateIf(
    (form: DeadlineRecurrenceFormDto) =>
      form.recurrence !== 'NONE' && !(form.recurrence === 'RECURRING' && form.dueAtOptional),
  )
  @IsIsoDay()
  dueAt?: string;

  /** Riga periodica nata senza data (es. da un template): modificarla non obbliga a inventarne una. */
  @IsOptional()
  @IsBoolean()
  dueAtOptional?: boolean;

  @ValidateIf((form: DeadlineRecurrenceFormDto) => form.recurrence === 'RECURRING')
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(MAX_RENEWAL_VALIDITY_MONTHS)
  validityMonths?: number;
}

export class TenantDeadlineFormDto extends DeadlineRecurrenceFormDto {
  @IsString()
  @IsNotEmpty()
  documentTypeId!: string;

  @IsBoolean()
  titleRequired!: boolean;

  @ValidateIf((form: TenantDeadlineFormDto) => form.titleRequired === true)
  @IsString()
  @IsNotEmpty()
  @MaxLength(DEADLINE_TITLE_MAX_LENGTH)
  title?: string;

  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string | null;
}

export class DeadlineEditFormDto extends DeadlineRecurrenceFormDto {
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_TITLE_MAX_LENGTH)
  title?: string;

  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string | null;

  @IsOptional()
  @IsBoolean()
  clientCanUpload?: boolean;

  @IsOptional()
  @IsBoolean()
  requestClientSignature?: boolean;
}
